var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0336 45.4179C41.3187 45.4179 42.3608 44.3108 42.3608 42.9456V3.0955C42.3608 1.72981 41.3187 0.6231 40.0336 0.6231H2.52245C1.23692 0.6231 0.195312 1.72981 0.195312 3.0955V42.9456C0.195312 44.3108 1.23692 45.4179 2.52245 45.4179H40.0336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2885 45.4179V28.0711H34.7696L35.5901 21.3106H29.2885V16.9944C29.2885 15.0371 29.8001 13.7033 32.4423 13.7033L35.8121 13.7016V7.65512C35.2291 7.57288 33.2289 7.38876 30.9017 7.38876C26.0432 7.38876 22.7171 10.5392 22.7171 16.3251V21.3106H17.2222V28.0711H22.7171V45.4179H29.2885Z",
    fill: "#122441"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.4484,
    height: 45.0954,
    fill: "white",
    transform: "translate(0.0537109 0.472778)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.713940f8c148c9f0f509541db6f18c0e.svg";
export { ForwardRef as ReactComponent };